import { render, staticRenderFns } from "./VrManage.vue?vue&type=template&id=ce5531ba&scoped=true&"
import script from "./VrManage.vue?vue&type=script&lang=js&"
export * from "./VrManage.vue?vue&type=script&lang=js&"
import style0 from "./VrManage.vue?vue&type=style&index=0&id=ce5531ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5531ba",
  null
  
)

component.options.__file = "VrManage.vue"
export default component.exports